// extracted by mini-css-extract-plugin
module.exports = {"Menu":"HorizontalMenu_Menu__26__Y","MenuWrapper":"HorizontalMenu_MenuWrapper__321xi"};